import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { withFatalCheck } from '../error/withFatalCheck'
import { Key, ProductMetaInfo } from './productMetaInfo'
import * as st from './productMetaInfo.module.scss'
import * as utilityClasses from '../utilityClasses.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'

const VISIBLE_ITEMS_ATF = 40
const movieAtfKeys = [
  Key.Directors,
  Key.Starring,
  Key.Genres,
  Key.Subtitles,
  Key.AudioTracks
]

const tvAtfKeys = [
  Key.Starring,
  Key.Genres,
  Key.Subtitles,
  Key.AudioTracks
]

const getFields = (isTV: boolean) => {
  return isTV ? tvAtfKeys : movieAtfKeys
}

export interface IATFProductMetaInfoProps
  extends WpsRuntime.atv.wps.DetailFragmentModelProps, AtfTreatmentProps {
  isTV: boolean
}
const AtfProductMetaInfoValid: React.ComponentType<IATFProductMetaInfoProps> = (
  props: IATFProductMetaInfoProps
) => {
  const fields = getFields(props.isTV)
  return (<div className={`${st.atfInfo} dv-dp-node-meta-info ${utilityClasses.fullWidth}`}>
    <ProductMetaInfo
      {...props}
      fields={fields}
      expandedItemsCount={VISIBLE_ITEMS_ATF}
      id="meta-info"
    />
  </div>)
}

export const AtfProductMetaInfo = withFatalCheck(AtfProductMetaInfoValid)
